import React from "react";
import PropTypes from "prop-types";
import {Controller} from "react-hook-form" ;
import ReactHookFormDropdownLetterboxToContacts from "root/ReactHookForm/ui/ReactHookFormDropdownLetterboxToContacts";

const DropdownLetterboxToContacts = ({ validate, control, name, readOnly, options, to_uid  }) =>
{
    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: true, validate: validate}}
            render={({field: { onChange, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,}) => (
                <ReactHookFormDropdownLetterboxToContacts name={name} to_uid={to_uid} onChange={onChange} value={value} inputRef={ref} options={options} readOnly={readOnly}/>
            )}/>
    )
}

export default DropdownLetterboxToContacts ;

DropdownLetterboxToContacts.propTypes = {
    to_uid: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
};
